import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ element: Component, ...rest }) {
  const token = localStorage.getItem("tokenlogin"); // Check token
  return token ? <Component {...rest} /> : <Navigate to="/admin" />;
}

export default ProtectedRoute;
